export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};
export const isFileVideo = (file: File) => {
  const match = file.type.split('/') || [];
  const type = match[0];
  if (type === 'video') {
    return true;
  }
  return false;
};
